import React from "react";
import { NavLink } from "react-router-dom";

const SectionSidebar = ({ title, items = [] }) => {
  return (
    <aside className="w-full lg:w-72 flex-shrink-0">
      <div className="bg-white border border-brand/15 lg:sticky lg:top-32">
        <div className="px-4 py-3 lg:px-5 lg:py-4 bg-brand text-surface">
          <h3 className="text-sm lg:text-base font-sans-ui font-semibold tracking-wider uppercase">
            {title}
          </h3>
        </div>
        <ul className="flex gap-2 overflow-x-auto p-3 lg:block lg:gap-0 lg:overflow-visible lg:p-0 lg:divide-y lg:divide-brand/10">
          {items.map((item) => (
            <li key={item.to} className="flex-shrink-0 lg:flex-shrink">
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `block whitespace-nowrap lg:whitespace-normal px-4 lg:px-5 py-2.5 lg:py-3 text-sm transition-colors border lg:border-0 ${
                    isActive
                      ? "bg-surface text-brand border-brand lg:border-l-4 font-semibold"
                      : "text-[#2a2a2a] hover:bg-surface/60 hover:text-brand border-brand/10 lg:border-l-4 lg:border-transparent"
                  }`
                }
              >
                {item.label}
              </NavLink>
              {item.children && (
                <ul className="hidden lg:block pl-5 pb-2">
                  {item.children.map((c) => (
                    <li key={c.to}>
                      <NavLink
                        to={c.to}
                        end
                        className={({ isActive }) =>
                          `block py-1.5 text-[13px] ${
                            isActive
                              ? "text-brand font-semibold"
                              : "text-[#3a3a3a] hover:text-brand"
                          }`
                        }
                      >
                        · {c.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default SectionSidebar;
